(function () {
  var STORAGE_KEY = 'lh_wishlist_handles';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode / disabled) - fail silently */
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function toggle(handle) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(handle);
    }
    saveWishlist(list);
    return list.indexOf(handle) > -1;
  }

  function remove(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    saveWishlist(list);
  }

  function updateButtons() {
    var list = getWishlist();
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var handle = btn.getAttribute('data-product-handle');
      var active = list.indexOf(handle) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    }
  }

  function updateCount() {
    var count = getWishlist().length;
    var counts = document.querySelectorAll('.wishlist-count');
    for (var i = 0; i < counts.length; i++) {
      counts[i].textContent = count;
    }
    var wraps = document.querySelectorAll('[data-wishlist-count-wrap]');
    for (var j = 0; j < wraps.length; j++) {
      wraps[j].classList.toggle('is-empty', count === 0);
    }
  }

  function refresh() {
    updateButtons();
    updateCount();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggle(handle);
  });

  document.addEventListener('wishlist:updated', refresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.LHWishlist = {
    getWishlist: getWishlist,
    isInWishlist: isInWishlist,
    toggle: toggle,
    remove: remove,
    refresh: refresh
  };
})();
